/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * as defs from './labeler/defs.js'
export * as getServices from './labeler/getServices.js'
export * as service from './labeler/service.js'
